import React from "react";

interface WidgetBoundaryProps {
  // Named in the fallback so a failing widget is identifiable without devtools.
  name: string;
  children: React.ReactNode;
}

interface WidgetBoundaryState {
  failed: boolean;
}

// The app mounts no error boundary of its own, so anything thrown while
// rendering unmounts the whole React root — the reason a single undefined
// figure blanked /admin, sidebar included. Each dashboard widget reads
// independent data from an independent endpoint, so each one fails alone.
export class WidgetBoundary extends React.Component<
  WidgetBoundaryProps,
  WidgetBoundaryState
> {
  state: WidgetBoundaryState = { failed: false };

  static getDerivedStateFromError(): WidgetBoundaryState {
    return { failed: true };
  }

  componentDidCatch(error: Error) {
    console.error(`Dashboard widget "${this.props.name}" failed:`, error);
  }

  render() {
    if (this.state.failed) {
      return (
        <div className="bg-white rounded-2xl shadow p-5 mb-8 text-sm text-gray-500">
          {this.props.name} could not be displayed.
        </div>
      );
    }
    return this.props.children;
  }
}
